import React, { useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
// import { customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, validatePaymentMode } from '../../components/constant';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import moment from 'moment';
import {customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from '../components/constant';

const LinkView =({ isReceiptEdit=false, isView=false,contextValue}) =>{
    const [errorMgs,setErrorMgs] = useState('')

      const {
        paymentModeFormHandler,
        studentBasicDetails, 
        paymentModeForm,
        validatePaymentMode,
        disableAmountField
    } = contextValue;
    return(
        <>
        <Row>
        <Col md="4">
            <div>
                <AInput
                    label="Link ID*"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.referenceNumber}
                    handler={(value) => {paymentModeFormHandler("referenceNumber",value) }}
                    placeholder="Enter"
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                    disabled={isView}
                />
            </div>
        </Col>
        <Col md="4">
            <div>
                <AInput
                    label="Transaction Amount*"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.paidAmount}
                    handler={(value) => {
                        if (
                            !value || parseFloat(value) > 0
                        ) {
                            paymentModeFormHandler('paidAmount',value)
                        }

                    }}
                    customIcon={
                        <div className='large-semi-bold'>&#8377;</div>
                      }
                      customIconStyle={customStyle}
                    placeholder="Enter amount"
                    style={inputAmountStyle}
                    disabled={isView||isReceiptEdit===true || disableAmountField}
                    regex={numberDecimalLimitRegex(10, 2)}
                />
            </div>
        </Col>
        <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Transaction date*"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select"
                            value={paymentModeForm?.paymentModeDate}
                            isStartDate={true}
                            minDate={studentBasicDetails?.detailsMap?.termStartDate}
                            maxDate={new moment(new Date())}
                            disabled={true}
                        />
                    </div>
                </Col>
        </Row>
        <Row>
                <Col md="4">
            <div>
            <AInput
                    label="Created By"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.createdBy}
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                    disabled={true}
                />
            </div>
        </Col>
        </Row>
        </>
    )
}
export default LinkView